/**
 * @file 剧本相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';

/**
 * 新建剧本生成剧本id
 * @returns Promise
 */
export const createId = async () => {
    return request(
        API.CREATE_ID, {
            method: 'POSTJSON'
        }
    );
};

/**
 * 剧本标题修改
 * @returns Promise
 */
export const saveTitle = async params => {
    return request(
        API.SAVE_TITLE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 剧本保存
 * @returns Promise
 */
export const saveScript = async params => {
    return request(
        API.SAVE, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 是否第一次创建剧本
 * @returns Promise
 */
export const isFirstCreateScript = async params => {
    return request(
        API.IS_FIRST_CREATE_SCRIPT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取剧本列表
 * @returns Promise
 */
export const getScriptList = async params => {
    return request(
        API.GET_SCRIPT_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取剧本内容
 * @returns Promise
 */
export const getScriptDetail = async params => {
    return request(
        API.GET_SCRIPT_DETAIL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 删除剧本
 * @returns Promise
 */
export const delScript = async params => {
    return request(
        API.DEL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 文心生成剧本
 * @returns Promise
 */
export const createAIGCScript = async params => {
    return request(
        API.CREATE_AIGC_SCRIPT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

export const createAIGCScriptV2 = async params => {
    return request(
        API.CREATE_AIGC_SCRIPT_V2, {
            method: 'POSTJSON',
            body: params
        });
};
// 问答脚本生成
export const createCustomScriptV2 = async params => {
    return request(
        API.CREATE_CUSTOM_SCRIPT_V2, {
            method: 'POSTJSON',
            body: params
        });
};

/**
 * 查询文心生成剧本进度
 * @returns Promise
 */
export const getAIGCScriptProgress = async params => {
    return request(
        API.GET_AIGC_SCRIPT_PROGRESS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

export const getAIGCScriptProgressV2 = async params => {
    return request(
        API.GET_AIGC_SCRIPT_PROGRESS_V2, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取文心生成剧本结果
 * @returns Promise
 */
export const getAIGCScriptResult = async params => {
    return request(
        API.GET_AIGC_SCRIPT_RESULT, {
            method: 'POSTJSON',
            body: params
        }
    );
};
export const getAIGCScriptResultV2 = async params => {
    return request(
        API.GET_AIGC_SCRIPT_RESULT_V2, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 文心任务已使用
 * @returns Promise
 */
export const setAIGCScriptResult = async params => {
    return request(
        API.SET_AIGC_SCRIPT_RESULT_USE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 文心脚本采纳打点
 * @returns Promise
 */
export const acceptAIGCScriptLog = async params => {
    return request(
        API.ACCEPT_AIGC_SCRIPT_LOG, {
            method: 'POSTJSON',
            body: params
        }
    );
};
export const acceptAIGCScriptLogV2 = async params => {
    return request(
        API.ACCEPT_AIGC_SCRIPT_LOG_V2, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 剧本检查接口
 * @returns Promise
 */
export const checkScript = async params => {
    return request(
        API.SET_AIGC_SCRIPT_RESULT_CHECK, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * GET_AIGC_SCRIPT_WENXIN_PROMPTS
 * @returns Promise
 */
export const getScriptWenxinPrompts = async params => {
    return request(
        API.GET_AIGC_SCRIPT_WENXIN_PROMPTS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 剧本优化建议回馈
 * @returns Promise
*/
export const setSuggestionFeedback = async params => {
    return request(
        API.SET_SUGGESTION_FEEDBACK, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 全局轮询接口
 */
export const getQueryProgress = async params => {
    return request(
        API.QUERY_PROGRESS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 剧本审核接口
 * @param {*} params
 * @returns
 */
export const checkRiskScript = async params => {
    return request(
        API.SCRIPT_RISK_CHECK, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 *判断是否是度小店商品
 * @param {*} params
 * @returns
 */
export const checkCanAIScript = async params => {
    return request(
        API.CAN_GEN_SCRIPT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 剧本创建快照记录接口
 * @param {*} params
 * @returns
 */
export const createSnapshot = params => {
    return request(
        API.SCRIPT_CENTER_SNAPSHOT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取剧本创建快照记录接口
 * @param {*} params
 * @returns
 */
export const getSnapshot = params => {
    return request(
        API.GET_SCRIPT_CENTER_SNAPSHOT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取图片推荐
 * @param {*} params
 * @returns
 */
export const getRecommendPaster = params => {
    return request(
        API.GET_RECOMMEND_PASTER, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取营销图片推荐
 * @param {*} params
 * @returns
 */
export const getPasterRecommend = params => {
    return request(
        API.GET_PASTER_RECOMMEND, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取视频推荐
 * @param {*} params
 * @returns
 */
export const getRecommendVideo = params => {
    return request(
        API.GET_RECOMMEND_VIDEO, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 检查是否可以新建线索
 */
export const checkCustomAcq = params => {
    return request(
        API.CHECK_CUSTOM_ACQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};